import { map } from '../styles/breakpoints';
export default function breakpointStyleProp(propName, styleFunc) {
  return function displayStyle(props) {
    var styleProp = props[propName];
    return map(styleProp, function (key) {
      if (key) {
        return styleFunc(key);
      }
      return '';
    });
  };
}